import { Injectable, inject } from '@angular/core';
import {LoadingState} from "../../shared/loading-state.enum";
import { HttpClient } from "@angular/common/http";
import {firstValueFrom} from "rxjs";
import {ResponseModel, SingleResponseModel} from "../../shared/response.model";
import {environment} from "../../../environments/environment";
import {IncomeType} from "./income-type.model";
import {MessageService} from "primeng/api";

@Injectable({
  providedIn: 'root'
})
export class IncomeTypeService {
  private http = inject(HttpClient);
  private messageService = inject(MessageService);

  loadingState = LoadingState.Loading;
  types: IncomeType[] = [];
  constructor() {
    void this.fetchIncomeTypes();
  }

  async fetchIncomeTypes(): Promise<void> {
    try {
      const response = await firstValueFrom(this.http.get<ResponseModel<IncomeType>>(environment.apiUrl + "/income-types"));
      this.types = response.data;
      this.loadingState = LoadingState.Data;
    } catch (e) {
      console.error(e);
      this.loadingState = LoadingState.Error;
      this.types = [];
    }
  }

  async deleteIncomeType(id: number): Promise<IncomeType | void> {
    try {
      const response = await firstValueFrom(this.http.delete<SingleResponseModel<IncomeType>>(environment.apiUrl + `/income-types/${id}`));
      this.messageService.add({
        severity: 'success',
        summary: 'Einkommensart gelöscht',
        detail: `${response?.data.title} wurde gelöscht.`
      });
      return response?.data;
    } catch (e) {
      console.error(e);
      this.messageService.add({
        severity: 'error',
        summary: 'Fehler',
        detail: `Einkommensart konnte nicht gelöscht werden.`
      });
    } finally {
      await this.fetchIncomeTypes();
    }
  }

  async updateIncomeType(type: IncomeType): Promise<IncomeType | void> {
    try {
      const response = await firstValueFrom(this.http.put<SingleResponseModel<IncomeType>>(environment.apiUrl + `/income-types/${type.id}`, {data: type}));
      this.messageService.add({
        severity: 'success',
        summary: 'Einkommensart aktualisiert',
        detail: `${response?.data.title} wurde aktualisiert.`
      });
      return response?.data;
    } catch (e) {
      console.error(e);
      this.messageService.add({
        severity: 'error',
        summary: 'Fehler',
        detail: `Einkommensart konnte nicht geändert werden.`
      });
    } finally {
      await this.fetchIncomeTypes();
    }

  }

  async createIncomeType(title: string): Promise<IncomeType | void> {
    try {
      const response = await firstValueFrom(this.http.post<SingleResponseModel<IncomeType>>(environment.apiUrl + `/income-types`, {data: {title}}));
      this.messageService.add({
        severity: 'success',
        summary: 'Einkommensart erstellt',
        detail: `${response?.data.title} wurde erstellt.`
      });
      return response?.data;
    } catch (e) {
      console.error(e);
      this.messageService.add({
        severity: 'error',
        summary: 'Fehler',
        detail: `Einkommensart konnte nicht erstellt werden.`
      });
    } finally {
      await this.fetchIncomeTypes();
    }
  }
}
